interface EnvironmentConfig {
    PUBLIC_PREFIX: string;
    VERSION_NUMBER?: string;
    EDEN_AUTH_CLIENT_KEY: string;
    // These should eventually be moved to the Config object instead of EnvironmentConfig.
    // They are used by the UI tests, which are not working with import.meta.env.
    RUM_CLIENT_TOKEN?: string;
    RUM_APPLICATION_ID?: string;
    RUM_SESSION_SAMPLE_RATE?: string;
    RUM_SESSION_REPLAY_SAMPLE_RATE?: string;
    LOGS_CLIENT_TOKEN?: string;
    LOGS_SESSION_SAMPLE_RATE?: string;
    WIDGETS_RUM_CLIENT_TOKEN?: string;
    WIDGETS_RUM_APPLICATION_ID?: string;
    WIDGETS_RUM_SESSION_SAMPLE_RATE?: string;
    WIDGETS_RUM_SESSION_REPLAY_SAMPLE_RATE?: string;
    WIDGETS_LOGS_CLIENT_TOKEN?: string;
    WIDGETS_LOGS_SESSION_SAMPLE_RATE?: string;
}

const ensureDefined = ([key, value]: [string, unknown]) => {
    if (value === undefined) {
        throw new Error(`Environment variable ${key} expected. Found undefined.`);
    }

    return value;
};

const EnvironmentConfig: EnvironmentConfig = {
    PUBLIC_PREFIX: process.env.PUBLIC_PREFIX || '',
    VERSION_NUMBER: process.env.VERSION_NUMBER || 'unknown-version',
    EDEN_AUTH_CLIENT_KEY: process.env.EDEN_AUTH_CLIENT_KEY || '',

    // These should eventually be moved to the Config object instead of EnvironmentConfig.
    // They are used by the UI tests, which are not working with import.meta.env.
    RUM_CLIENT_TOKEN: process.env.VITE_RUM_CLIENT_TOKEN || '',
    RUM_APPLICATION_ID: process.env.VITE_RUM_APPLICATION_ID || '',
    RUM_SESSION_SAMPLE_RATE: process.env.VITE_RUM_SESSION_SAMPLE_RATE || '0',
    RUM_SESSION_REPLAY_SAMPLE_RATE: process.env.VITE_RUM_SESSION_REPLAY_SAMPLE_RATE || '0',
    LOGS_CLIENT_TOKEN: process.env.VITE_LOGS_CLIENT_TOKEN || '',
    LOGS_SESSION_SAMPLE_RATE: process.env.VITE_LOGS_SESSION_SAMPLE_RATE || '0',
    WIDGETS_RUM_CLIENT_TOKEN: process.env.VITE_WIDGETS_RUM_CLIENT_TOKEN || '',
    WIDGETS_RUM_APPLICATION_ID: process.env.VITE_WIDGETS_RUM_APPLICATION_ID || '',
    WIDGETS_RUM_SESSION_SAMPLE_RATE: process.env.VITE_WIDGETS_RUM_SESSION_SAMPLE_RATE || '0',
    WIDGETS_RUM_SESSION_REPLAY_SAMPLE_RATE: process.env.VITE_WIDGETS_RUM_SESSION_REPLAY_SAMPLE_RATE || '0',
    WIDGETS_LOGS_CLIENT_TOKEN: process.env.VITE_WIDGETS_LOGS_CLIENT_TOKEN || '',
    WIDGETS_LOGS_SESSION_SAMPLE_RATE: process.env.VITE_WIDGETS_LOGS_SESSION_SAMPLE_RATE || '0',
};

Object.entries(EnvironmentConfig).forEach(ensureDefined);

export default EnvironmentConfig;
